import { Outlet } from "react-router-dom";
import { PlanList } from "./PlanList";
import { Features } from "./Features";

export const plansRoutes = [
  {
    path: "plans",
    element: Outlet,
    children: [
      {
        path: "",
        redirect: "list",
      },
      {
        path: "list",
        element: PlanList,
      },
      {
        path: "features",
        element: Features,
      },
    ],
  },
];
